import React from "react";
import { useHistory } from "react-router-dom";
import { RouteNames } from "routes/routes";
import ContainerFlex from "components/ContainerFlex";
import Checkbox from "components/checkbox";
import Button from "components/button";

import * as St from "./styles";
import { useAppDispatch, useAppSelector } from "redux/app/hooks";
import {
  termosUso,
  termoWhatsapp,
} from "redux/features/cartao/desbloqueio-slice";

const TermoWhatsApp: React.FC = () => {
  const history = useHistory();
  const { telaBloqueio } = useAppSelector((state) => state.cartao);
  const dispatch = useAppDispatch();
  const [checkedTerms, setCheckedTerms] = React.useState(false);
  const [checkedWhatsApp, setCheckedWhatsApp] = React.useState(false);

  const handleVoltar = () => {
    history.push(RouteNames.HOME);
  };

  const handleTermosPrivacidade = () => {
    history.push(RouteNames.TERMO_PRIVACIDADE_PDF);
  };

  const handleTermosCondicoes = () => {
    history.push(RouteNames.TERMO_DE_USO_PDF);
  };

  const handleContinuar = async () => {
    dispatch(termosUso(checkedTerms));
    dispatch(termoWhatsapp(checkedWhatsApp));
    if (telaBloqueio) {
      history.push(RouteNames.UNLOCK_CLIENTE_CARTAO);
    } else {
      history.push(RouteNames.UNLOCK_CLIENTE_PUSH_SMS);
    }
  };

  return (
    <ContainerFlex center flex={1} horizontal space>
      <ContainerFlex center>
        <ContainerFlex center>
          <St.Title>Desbloqueio</St.Title>
        </ContainerFlex>

        <ContainerFlex center maxWidth={60}>
          <ContainerFlex center padding={25}>
            <Checkbox
              message="Desejo receber comunicação do meu interesse por WhatsApp."
              onChangeStatus={(status: boolean) => setCheckedWhatsApp(status)}
              value={checkedWhatsApp}
            />
          </ContainerFlex>

          <ContainerFlex center padding={25}>
            <Checkbox
              message="Li e concordo com os Termos e condições de uso e a Política de privacidade."
              onChangeStatus={(status: boolean) => setCheckedTerms(status)}
              value={checkedTerms}
            />
          </ContainerFlex>
        </ContainerFlex>
      </ContainerFlex>

      <ContainerFlex gap="4px" row horizontal marginTop={90}>
        <ContainerFlex>
          <Button onClick={handleVoltar} size="large" outlined>
            <span>Voltar</span>
          </Button>
        </ContainerFlex>
        <ContainerFlex center>
          <Button onClick={handleTermosCondicoes} size="large">
            <span>Ler termos e condições de uso</span>
          </Button>
        </ContainerFlex>
        <ContainerFlex center>
          <Button onClick={handleTermosPrivacidade} size="large">
            <span>Ler política de privacidade</span>
          </Button>
        </ContainerFlex>
        <ContainerFlex end align="flex-end">
          <Button
            onClick={handleContinuar}
            size="large"
            disabled={!checkedTerms || !checkedWhatsApp}
          >
            <span>Continuar</span>
          </Button>
        </ContainerFlex>
      </ContainerFlex>
    </ContainerFlex>
  );
};

export default TermoWhatsApp;
